import { ArrowLeftThin, ArrowRightThin, ArrowDown } from '@ori-ui/icons';
const defaultProps = {
  components: {
    LeftArrowIcon: ArrowLeftThin,
    RightArrowIcon: ArrowRightThin,
    SwitchViewIcon: ArrowDown
  }
};
export default {
  defaultProps
};
//# sourceMappingURL=MuiDateCalendar.js.map